// login()/refreshAccessToken() eran el login propio de DTmood (usuario +
// contraseña) -- ya no se usan, DTmood acepta el token de Keycloak
// directamente (ver dtMoodApiHandler.js). Se dejan sin tocar porque
// LoginDtMood.jsx (pantalla vieja, dead code, ver CLAUDE.md) todavía las
// importa, pero nada las invoca en el flujo real.
import axios from 'axios'
import API from '../../../api'
import apiDtMood from './dtMoodApiHandler'

const apiDtMoodLegacy = axios.create({
  baseURL: API.urlDtMood
})

const login = (data) => {
  return new Promise((resolve, reject) => {
    apiDtMoodLegacy
      .post('/auth/login/', data)
      .then((res) => {
        resolve(res.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

const refreshAccessToken = (token) => {
  return new Promise((resolve, reject) => {
    apiDtMoodLegacy
      .post('/auth/refresh-token', { refreshToken: token })
      .then((res) => {
        resolve(res.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

// Sigue siendo real: es el "whoami" de DTmood (por email) que resuelve
// groupId/userId/clientId -- IDs internos de DTmood que Keycloak no
// conoce y que varios services de este módulo necesitan (ver
// dtmood-session.service.js). Antes se llamaba con el Bearer del login
// propio de DTmood; ahora usa apiDtMood (Bearer de Keycloak, ya aceptado
// por DTmood) -- se invoca una vez tras el login en src/index.js.
const getUser = (email) => {
  return new Promise((resolve, reject) => {
    apiDtMood
      .get(`/users?email=${encodeURIComponent(email)}`)
      .then((res) => {
        resolve(res.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export { login, getUser, refreshAccessToken }
